// Pending-new-tasks counter (Состояния интерфейса · live).
//
// When a `task.created` event arrives over the WebSocket while the manager is on
// Today, we DON'T silently refetch (which would shift the list under their
// finger). Instead we bump this counter; TodayScreen shows a "Показать новые [N]"
// pill and only refetches when the manager taps it. A tiny module-level store +
// subscribe so RealtimeBridge (writer) and TodayScreen (reader) stay decoupled.
import { useEffect, useState } from 'react'

let _count = 0
const listeners = new Set<(n: number) => void>()

function emit(): void {
  for (const l of listeners) l(_count)
}

export function bumpPending(n = 1): void {
  _count += n
  emit()
}

export function flushPending(): void {
  if (_count === 0) return
  _count = 0
  emit()
}

export function getPending(): number {
  return _count
}

export function subscribePending(fn: (n: number) => void): () => void {
  listeners.add(fn)
  return () => {
    listeners.delete(fn)
  }
}

/** Reactive read for components. */
export function usePendingNew(): number {
  const [n, setN] = useState(getPending())
  useEffect(() => subscribePending(setN), [])
  return n
}
